export default {
  // 时间间隔options
  interval: [
    { label: "0.5h", value: "0.5h" },
    { label: "1h", value: "1h" },
    { label: "1.5h", value: "1.5h" },
    { label: "2h", value: "2h" },
    { label: "2.5h", value: "2.5h" },
    { label: "3h", value: "3h" },
    { label: "3.5h", value: "3.5h" },
    { label: "4h", value: "4h" },
    { label: "4.5h", value: "4.5h" },
    { label: "5h", value: "5h" },
    { label: "5.5h", value: "5.5h" },
    { label: "6h", value: "6h" },
    { label: "6.5h", value: "6.5h" },
    { label: "7h", value: "7h" },
    { label: "7.5h", value: "7.5h" },
    { label: "8h", value: "8h" }
  ],
  // 优惠券类型
  coupon: [
    { label: "满减券", value: 1 },
    { label: "满折券", value: 2 },
    { label: "换购券", value: 3 }
  ],
  // 抽奖状态
  luckyDraw: [
    { label: "待开始", value: 0 },
    { label: "进行中", value: 1 },
    { label: "已开奖", value: 2 }
  ],
  // 订单状态
  orderStatus: [
    { label: "退款失败", value: -3 },
    { label: "支付失败", value: -2 },
    { label: "已取消", value: -1 },
    { label: "待支付", value: 0 },
    { label: "待接单", value: 1 },
    { label: "待出餐", value: 2 },
    { label: "待取餐", value: 3 },
    { label: "待配送", value: 4 },
    { label: "配送中", value: 5 },
    { label: "已完成", value: 6 },
    { label: "退款审核中", value: 7 },
    { label: "退款中", value: 8 },
    { label: "已退款", value: 9 }
  ],
  // 订单类型
  orderType: [
    { label: "堂食", value: 1 },
    { label: "外卖", value: 2 },
    { label: "自取", value: 3 }
  ],
  // 优惠券使用类型
  couponUseType: [
    { label: "未使用", value: 1 },
    { label: "已使用", value: 2 },
    { label: "已失效", value: 3 }
  ],
  // 打印机类型
  printerType: [
    { label: "网口打印机", value: 1 },
    { label: "USB打印机", value: 2 }
  ],
  // 设备类型
  deviceBrand: [
    { label: "佳博", value: 1 },
    { label: "飞鸽", value: 2 },
    { label: "芯烨", value: 3 }
  ],
  publishStatus: [
    {
      value: 1,
      label: "已上架"
    },
    {
      value: 0,
      label: "已下架"
    }
  ],
  couponStatus:[
    { label: "未领完", value: 0 },
    { label: "已领完", value: 1 },
    { label: "已关闭", value: 2 }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/options.js